// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".79a5c5d1db17285c497a6d8d9ad778fb.js";
};